import { useTranslation } from 'react-i18next';
import { usePage, Link } from '@inertiajs/react';
import Sidebar, { getTeacherNavItems, getStudentNavItems } from '../../../components/layout/Sidebar';
import ImpersonationBanner from '../../../components/layout/ImpersonationBanner';
import ThemeToggle from '../../../components/ui/ThemeToggle';
import { Card } from '../../../components/ui';
import Logo from '../../../components/ui/Logo';
import { SLUG_TO_QUIZ } from '../../../data/atlas_quizzes';

export default function AtlasQuizzesIndex() {
  const { t } = useTranslation();
  const { auth } = usePage().props;
  const user = auth?.user;
  const isTeacher = user?.role === 'teacher' || user?.role === 'admin';
  const navItems = isTeacher ? getTeacherNavItems(user?.role, t) : getStudentNavItems(t);
  const quizzes = Object.values(SLUG_TO_QUIZ);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white dark:from-gray-900 dark:to-gray-950">
      <ImpersonationBanner />
      <div className="flex h-screen overflow-hidden">
        <Sidebar items={navItems} />

        <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
          <header className="flex-shrink-0 h-14 bg-white/80 backdrop-blur-md border-b border-gray-200 dark:bg-gray-900/80 dark:border-gray-700 z-30">
            <div className="flex items-center justify-between h-full px-4">
              <div className="flex items-center gap-3 min-w-0 flex-1">
                <Link href={isTeacher ? '/teacher/dashboard' : '/'} className="flex items-center gap-2 flex-shrink-0">
                  <Logo className="h-9" />
                </Link>
                <div className="flex items-center gap-2 pl-3 border-l border-gray-300 dark:border-gray-600">
                  <Link href="/atlas" className="text-sm font-medium text-gray-900 dark:text-white hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                    {t('nav.atlas')}
                  </Link>
                </div>
              </div>
              <ThemeToggle />
            </div>
          </header>

          <main className="flex-1 overflow-y-auto px-6 py-8">
            <div className="max-w-3xl mx-auto">
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-1">
                {t('atlas.quizzesTitle')}
              </h1>
              <p className="text-sm text-gray-500 dark:text-gray-400 mb-8">
                {t('atlas.quizzesSubtitle')}
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {quizzes.map((quiz) => (
                  <Link key={quiz.slug} href={`/atlas/quizzes/${quiz.slug}`} data-testid={`atlas-quiz-card-${quiz.slug}`}>
                    <Card className="h-full hover:shadow-md transition-shadow">
                      <p className="text-xs font-medium text-gray-400 dark:text-gray-500 uppercase tracking-wide mb-1">
                        {quiz.course_context}
                      </p>
                      <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                        {quiz.title}
                      </h2>
                      <p className="text-sm text-gray-500 dark:text-gray-400">
                        {t('atlas.questionCount', { count: quiz.questions.length })}
                      </p>
                    </Card>
                  </Link>
                ))}
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
